import type { ErrorT } from "~/services/api-schemas";

import { camelCase } from "~/utils/casing";

export interface ExtractResponseErrorsOptions {
  /** @default true */
  ensurePunctuation?: boolean;
}

export function camelizeErrorSource(error: ErrorT): ErrorT {
  const result = { ...error };
  if (result.source) result.source = camelCase(result.source);

  return result;
}
